const ForcedSuccess = () => (
  <svg
    aria-hidden="true"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 28.125C7.76288 28.125 1.875 22.2371 1.875 15C1.875 7.76288 7.76288 1.875 15 1.875C22.2371 1.875 28.125 7.76288 28.125 15C28.125 22.2371 22.2371 28.125 15 28.125Z"
      fill="#72C472"
    />
    <path
      d="M12.3748 21.5625C12.0388 21.5625 11.7028 21.4339 11.4469 21.178L7.5094 17.2405C6.99621 16.7273 6.99621 15.8978 7.5094 15.3846C8.02259 14.8714 8.85209 14.8714 9.36528 15.3846L12.3748 18.3941L20.6344 10.1346C21.1476 9.6214 21.9771 9.6214 22.4903 10.1346C23.0035 10.6478 23.0035 11.4773 22.4903 11.9905L13.3028 21.178C13.0468 21.4339 12.7108 21.5625 12.3748 21.5625Z"
      fill="white"
    />
  </svg>
)

export default ForcedSuccess
